import { branchConfigApi } from '../../api';
import { BranchRegistrationDTO, BranchUpdateDTO } from '../../types/branches/configuration/BranchTypes';

const BranchConfigurationService = {
    /**
     * Crear una nueva sucursal
     * POST /api/configuration/branches
     */
    createBranch: async (data: BranchRegistrationDTO) => {
        const response = await branchConfigApi.add(data);
        return response.data;
    },

    /**
     * Actualizar una sucursal
     * PUT /api/configuration/branches/{id}
     */
    updateBranch: async (id: number, data: BranchUpdateDTO) => {
        const response = await branchConfigApi.modify(id, data);
        return response.data;
    },

    /**
     * Obtener detalle de una sucursal por ID
     * GET /api/configuration/branches/{id}
     */
    getBranchById: async (id: number) => {
        const response = await branchConfigApi.fetchById(id);
        return response.data;
    },

    /**
     * Alternar estado de sucursal (activar/desactivar)
     * PATCH /api/configuration/branches/{id}/toggle-status
     */
    toggleBranchStatus: async (id: number) => {
        const response = await branchConfigApi.patchCustom(`${id}/toggle-status`);
        return response.data;
    },

    /**
     * Obtener lista de tipos de establecimiento para dropdown
     * GET /api/configuration/branches/establishment-types
     */
    getEstablishmentTypes: async () => {
        const response = await branchConfigApi.fetchCustom('/establishment-types');
        return response.data;
    },
    /**
     * Obtener sucursales paginadas
     * GET /api/configuration/branches?page=0&size=10&sort=...
     */
    getBranchesPaged: async (page = 0, size = 10, sort = 'establishmentCode,asc') => {
        const response = await branchConfigApi.fetchCustom(
            `?page=${page}&size=${size}&sort=${sort}`
        );
        return response.data;
    },

};

export default BranchConfigurationService;
